import axios from 'axios';

export default {
  async getProductList(context, { sort, payload }) {
    try {
      const { data } = await axios.post(
        `${process.env.API_BASE_URL}/products/health/hcp${sort ? `?sort=${sort}` : ''}`,
        payload
      );
      const response = data;
      context.commit('setListProduct', response.data);
    } catch (error) {
      return error;
    }
  }
};
